export const GET_TEXT_INFO_SUCCESS = 'GET_TEXT_INFO_SUCCESS';
export const SET_TEXT_DELIVERED_SUCCESS = 'SET_TEXT_DELIVERED_SUCCESS';
export const SET_TEXT_AS_NOT_DELIVERED_SUCCESS = 'SET_TEXT_AS_NOT_DELIVERED_SUCCESS';
export const GET_AVAILABLE_COPYWRITERS_SUCCESS = 'GET_AVAILABLE_COPYWRITERS_SUCCESS';
export const SET_COPYWRITER_ON_ORDER_SUCCESS = 'SET_COPYWRITER_ON_ORDER_SUCCESS';
